import React from 'react';
import { Text, TextProps } from '../../Text';
import { useCustomComponent } from '@/hooks';

export interface ChatMessageTextProps extends TextProps {}

const MessageTextComponent: React.FC<ChatMessageTextProps> = props => {
  return <Text {...props} />;
};

export const MessageText: React.FC<ChatMessageTextProps> = (
  props: ChatMessageTextProps
) => {
  const Component = useCustomComponent({
    componentName: 'ChatMessageText',
    Component: MessageTextComponent,
  });

  return <Component {...props} />;
};
